import React from 'react';
import { Modal } from 'react-bootstrap';

import api from '../../apiClient/v1';

class FacturacionMensual extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
        }
        this.show = () => this.setState({ visible: true })
        this.hide = () => this.setState({ visible: false })
    }
    
    handleDownloadExcel = (fechaMes) => {
        try {
            const url = `/auditorias/excel-facturacion/${fechaMes}`
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `facturacion_ird_${fechaMes}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.log(error)
        }
    };

    renderMonthsButtons = () => {
        const currentDate = new Date();
        const months = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        const monthsInRange = [];
        let year = currentDate.getFullYear();
        let month = currentDate.getMonth();
    
        for (let i = 0; i < 12; i++) {
            monthsInRange.push({ month, year });
            if (month === 0) {
                month = 11;
                year--;
            } else {
                month--;
            }
        }

        return monthsInRange.map(({ month, year }, index) => {
            let mes = month + 1
            if (mes < 10) {
                mes = `0${mes}`
            }
            const fechaLink = `${year}-${mes}-01`;
            const formattedDate = `${months[month]} ${year}`;
    
            return (
                <div className="col-sm-4" key={index} style={{ display: 'flex', justifyContent: 'center', marginBottom: '2px' }}>
                    <a
                    href={`/auditorias/excel-facturacion/${fechaLink}`}
                    className='btn btn-primary'
                    style={{ width: '150px' }}
                    //onClick={() => this.handleDownloadExcel(fechaLink)}
                >
                    {formattedDate}
                </a>
                </div>
            );
        });
    };

    render() {
        return (
            <div>
                <button className='btn btn-success btn-xs' onClick={this.show}>Detalle Mensual</button>
                <Modal show={this.state.visible} onHide={this.hide}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{display: "flex", gap: "12px", alignItems: "center"}}>
                                <span>Seleccione fecha para ver facturación</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            {this.renderMonthsButtons()}
                        </div>
                    </Modal.Body >
                </Modal >
            </div >
        );
    }
}

export default FacturacionMensual;


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/FacturacionMensual.jsx